import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type { FeatureInitApi } from '../feature-init-api';
import type { FeatureInitResponse } from '../../types';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import type { QueryFeaturePermissionsApi, QueryFeaturePermissionsRequest, QueryFeaturePermissionsResponse } from '../query-feature-permissions-api';
import type { PlgAgentFeatureCheckApi, PlgAgentFeatureCheckRequest, PlgAgentFeatureCheckResponse } from '../plg-agent-feature-check-api';
import { isUserLogin } from '@telecom/shared/startup/user-auth';


@injectable()
export class FeatureInitApiImpl extends PsHttpService
    implements
        FeatureInitApi,
        QueryFeaturePermissionsApi,
        PlgAgentFeatureCheckApi
{

    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async getFeatureInit(): Promise<FeatureInitResponse> {
        const result = await this.get<PatSnapSuccessResponseData<FeatureInitResponse>>({
            url: '/v1/feature-init',
        });
        return result.data;
    }

    async queryFeaturePermissions(params: QueryFeaturePermissionsRequest): Promise<QueryFeaturePermissionsResponse> {
        const login = await isUserLogin();
        const result = await this.get<PatSnapSuccessResponseData<QueryFeaturePermissionsResponse>>({
            url: '/user-capacity/feature-permissions',
            baseURL: login ? coreTelecomApiUrlPrefix: coreTelecomApiUrlPrefix.replace('/core-telecom-api/', '/public-share/'),
            params,
        });
        return result.data;
    }

    async checkPlgAgentFeature(params: PlgAgentFeatureCheckRequest): Promise<PlgAgentFeatureCheckResponse> {
        const result = await this.post<PatSnapSuccessResponseData<PlgAgentFeatureCheckResponse>>({
            url: '/user-capacity/plg-agent-feature/check',
            data: params,
        });
        return result.data;
    }
}
